import { useState } from "react";
import { Button } from "@/components/ui/button";
import { IAirdropTaskRender } from "./task-renderer.types";
import { getAirdropArgumentValue } from "@/lib/challenges";
import { ChallengeCampaignEventState } from "@/types";
import { QuestTaskButton } from "../quest-task-button";
import { Twitter } from "lucide-react";

export const MediaRenderer = ({
  task,
  completeTaskMutation,
  campaign,
}: IAirdropTaskRender) => {
  const [url, setUrl] = useState(task.extraArguments?.[0] || undefined);
  const args =
    campaign.tasks?.find((campaignTask) => campaignTask.id === task.taskGuid)
      ?.arguments ?? [];

  const type = getAirdropArgumentValue(args, "type") ?? "";
  const tweetText = getAirdropArgumentValue(args, "tweetText") ?? "";

  const isDisabled =
    task.status === ChallengeCampaignEventState.PENDING ||
    task.status === ChallengeCampaignEventState.SUCCESSFUL ||
    !!task.cooldown ||
    completeTaskMutation.isPending;

  const label = type === "twitter" ? "X Link" : "Input";
  const placeholder = "https://x.com/status/...";

  return (
    <div className="flex flex-col gap-4">
      <div className="relative bg-yiedl-gray-200 border-2 border-neutral-800 rounded-xl p-4">
        <input
          disabled={
            task.status !== ChallengeCampaignEventState.ERROR || isDisabled
          }
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-transparent border-none outline-none text-white placeholder:text-gray-500 text-sm disabled:opacity-50"
        />
      </div>

      {tweetText && (
        <Button
          variant="secondary"
          size="lg"
          className="w-full"
          onClick={() => {
            const formattedText = tweetText.replace(/\\n/g, "\n");
            const encodedText = encodeURIComponent(formattedText);
            window.open(
              `https://twitter.com/intent/tweet?text=${encodedText}`,
              "_blank"
            );
          }}
        >
          <Twitter className="w-4 h-4 mr-2" />
          Tweet
        </Button>
      )}

      <QuestTaskButton
        buttonText="Claim"
        taskMutation={completeTaskMutation}
        task={task}
        onClick={() => {
          completeTaskMutation.mutateAsync({
            campaignId: campaign.id,
            groupId: campaign.campaignGroup,
            taskName: task.taskName,
            extraArguments: [url ?? ""],
            taskGuid: task.taskGuid,
          });
        }}
      />
    </div>
  );
};
